import { Button } from "antd";
import dayjs from "dayjs";
import { useCallback, useMemo, useState } from "react";
import { PermissionNames } from "~enums/permissions";
import HistoricNames, { AddHistoricNameModal } from "~Features/HistoricalNames/index.jsx";
import { useUpsertCompetition } from "~pages/Competitions/hooks/useUpsertCompetition.js";

const NameComponent = ({ value }) => {
  return <>{value}</>;
};

const EditButton = ({ historicalNames, fetchData, row, handleUpdate }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      <AddHistoricNameModal
        historicalNames={historicalNames}
        fetchData={fetchData}
        defaultName={row.nameLocal}
        defaultStartDate={dayjs(row.dateStart)}
        defaultEndDate={dayjs(row.dateEnd)}
        isAddModalOpen={isModalOpen}
        setIsAddModalOpen={setIsModalOpen}
        isEditMode={true}
        handleUpdate={handleUpdate}
        modalTitle={"competitions.name"}
      />
      <Button
        outline
        color="primary"
        size="sm"
        onClick={() => {
          setIsModalOpen(true);
        }}
      >
        <i className="fas fa-pen" />
      </Button>
    </>
  );
};

const columns = (historicalNames, fetchData, handleUpdate) => [
  {
    title: "Competition Name",
    dataIndex: "nameLocal",
    key: "nameLocal",
    render: (value) => <NameComponent value={value} />,
  },
  {
    title: "Start Date",
    dataIndex: "dateStart",
    key: "dateStart",
    render: (value) => <div>{dayjs(value).format("DD-MM-YYYY")}</div>,
  },
  {
    title: "End Date",
    dataIndex: "dateEnd",
    key: "dateEnd",
    render: (value) => <div>{dayjs(value).format("DD-MM-YYYY")}</div>,
  },
  {
    render: (_, row) => <EditButton historicalNames={historicalNames} fetchData={fetchData} row={row} handleUpdate={handleUpdate} />,
  },
];

const CompetitionHistoricNames = ({ data, fetchData }) => {
  const { mutateAsync: updateFn } = useUpsertCompetition();

  const handleUpdate = useCallback(
    async (value, isEditMode, defaultValue) => {
      const historicalNames = data.historicalNames || [];
      let updated = [];
      if (!isEditMode) {
        updated = [
          ...historicalNames,
          {
            nameLocal: value.nameFullLocal,
            dateStart: value.dateStart,
            dateEnd: value.dateEnd,
          },
        ];
      } else {
        updated = historicalNames.map((item) =>
          item.nameLocal === defaultValue.defaultName &&
          dayjs(item.dateStart).isSame(defaultValue.defaultStartDate) &&
          dayjs(item.dateEnd).isSame(defaultValue.defaultEndDate)
            ? {
                nameLocal: value.nameFullLocal,
                dateStart: value.dateStart,
                dateEnd: value.dateEnd,
              }
            : item,
        );
      }
      await updateFn({ historicalNames: updated, competitionId: data.competitionId });
    },
    [data.historicalNames, updateFn, data.competitionId],
  );

  const tableColumns = useMemo(() => {
    return columns(data.historicalNames, fetchData, handleUpdate);
  }, [fetchData, handleUpdate, data.historicalNames]);

  return (
    <HistoricNames
      historicalNames={data?.historicalNames}
      fetchData={fetchData}
      columns={tableColumns}
      handleUpdate={handleUpdate}
      modalTitle={"competitions.name"}
      permissionName={PermissionNames.COMPETITION}
    />
  );
};

export default CompetitionHistoricNames;
